module.exports = __webpack_public_path__ + "img/coloured-card.6e165911.jpg";